import React from 'react'


const openTogger = (evt) => {
    let parentElm = getParentElement(evt.target);
    let nextElm = parentElm.nextElementSibling;
    if(parentElm.getAttribute("class").indexOf("collapsed") !== -1){
        parentElm.setAttribute("class","quesiton");
        nextElm.setAttribute("class","collapse show");
    } else {
        parentElm.setAttribute("class","quesiton collapsed");
        nextElm.setAttribute("class","collapse");
    }
}

const getParentElement = (elm) => {
    let parentElm = elm;
    for (var i = 0; i < 5; i++) {
        if (parentElm.getAttribute("class") !== null && parentElm.getAttribute("class").indexOf("quesiton") !== -1) {
            return parentElm;
        } else {
            parentElm = parentElm.parentElement;
        }
    }
    return undefined;
}

export default (props) => (
    <section id="faq">
        <div className="anueContainer">
            <div className="titleBlock">
                <h2 data-aos="flip-up">常見問題</h2>
                <div className="hr"></div>
            </div>
            <div className="anueContainer faq">
                {
                    props.FAQInfo.length !== 0 ?
                        props.FAQInfo.map(({ CQuestion, CAnswer }, index) => {
                            return <div className="quesitonContainer" data-aos="fade-left" key={index}>
                                <div className="quesiton collapsed" onClick={openTogger}>
                                    <div className="q"><span className="qSpan">Q</span></div>
                                    <div className="txt">
                                        <p>{CQuestion}</p>
                                    </div>
                                    <div className="arrow"></div>
                                </div>
                                <div className="collapse" id={"q" + (index + 1)}>
                                    <div className="answer">
                                        <div className="a">A</div>
                                        <div className="txt" dangerouslySetInnerHTML={{ __html: CAnswer }}></div>
                                    </div>
                                </div>
                            </div>
                        }) : ""
                }
            </div>
        </div>
    </section>
)